const Home = () => {
  return <h1>Inicio</h1>;
};

export default Home;
